export default __webpack_public_path__ + "static/media/bb_guess_1.b740de62.png";